import BaseElement from './BaseElement'
import { WishlistProductSlideout } from '../components/WishlistProductSlideout'

export default class WishlistProductSlideoutElement extends BaseElement {
  static get observedAttributes () {
    return ['product-id', 'product-handle', 'data-product']
  }

  renderElement () {
    const productId = parseInt(this.getAttribute('product-id') as string)
    const productHandle = this.getAttribute('product-handle')

    this.rootElement.render(<WishlistProductSlideout productId={productId} productHandle={productHandle}/>)
  }
}
